<template>
  <div class="h-screen flex w-full  vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card no-shadow>
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onClickSave)" autocomplete="off">
            <div slot="no-body" class="full-page-bg-color">
              <div class="vx-row">
                <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center text-center">
                  <span class="mx-auto text-big text-white">M-Hub PARTNER</span>
                  <!-- <img :src="company_logo" class="mx-auto" width="250"> -->
                </div>
                <div class="vx-col sm:w-1/2 md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
                  v-if="is_verified">
                  <div class="p-8">
                    <div class="vx-card__title mb-8">
                      <h4 class="mb-4">Setup Your Account <br>{{ form.email }}</h4>
                      <p>Please setup your new password.</p>
                    </div>
                    <!-- <vs-input type="email" label-placeholder="Your Email" v-model="form.email" class="w-full mb-6" /> -->
                    <ValidationProvider vid="password" name="password"
                      rules="required|no_whitespace|one_uppercase|one_lowercase|one_number|one_special|min:8"
                      v-slot="{ errors }">
                      <vs-input name="password" type="password" label-placeholder="Password" v-model="form.password"
                        class="w-full mb-6" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather" />
                    </ValidationProvider>
                    <ValidationProvider vid="password_confirmation" name="password_confirmation"
                      rules="required|no_whitespace|one_uppercase|one_lowercase|one_number|one_special|min:8"
                      v-slot="{ errors }">
                      <vs-input name="password_confirmation" type="password" label-placeholder="Confirm Password"
                        v-model="form.password_confirmation" class="w-full mb-8" :danger="!!errors[0]"
                        :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                    </ValidationProvider>

                    <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                      <vs-button type="border" to="/pages/login" size="small"
                        class="w-full sm:w-auto sm:mb-auto sm:mt-auto">Go
                        Back To Login
                      </vs-button>
                      <vs-button id="submit-button" button="submit" class="w-full sm:w-auto" size="small">Save Changes</vs-button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </vx-card>
    </div>
  </div>
</template>


<script>
import VueCountdown from '@chenfengyuan/vue-countdown'
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
const StaffRepository = RepositoryFactory.get('staff');
const UserRepository = RepositoryFactory.get('user');
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      value1: '',
      code: this.$route.params.code,
      userNotFound: false,
      isLoading: true,
      message: '',
      form: {
        email: '',
        code: this.$route.params.code,
        password: '',
        password_confirmation: ''
      },
      is_verified: true
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  async mounted() {
    // const is_logged = store.getters.currentUser
    await this.checkVerification();
  },
  components: {
    'countdown': VueCountdown
  },
  methods: {
    ...mapActions(['login']),
    async checkVerification() {
      this.isLoading = true
      try {
        const { data } = (await UserRepository.accountVerify(this.code)).data
        this.form.email = data.email
        this.is_verified = data.is_email_verified
        if (data.is_password_set && data.is_email_verified) {
          this.$router.push('/pages/login')
        } else {
          this.showSuccessMessage('Your account verified. Please set your password!')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
        this.$router.push('/pages/login')
      }
    },
    async onClickSave() {
      await this.$vs.loading({
        container: '#submit-button',
        scale: 0.45
      })
      try {
        await UserRepository.storeStaffPassword(this.form)
        await this.login({
          email: this.form.email,
          password: this.form.password,
        })
        this.$router.push('/')
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      await this.$vs.loading({
        container: '#submit-button',
        scale: 0.45
      })
    }
  }
}

</script>
